import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=058d6030&scoped=true&"
import script from "./editDialog.vue?vue&type=script&lang=js&"
export * from "./editDialog.vue?vue&type=script&lang=js&"
import style0 from "./editDialog.vue?vue&type=style&index=0&id=058d6030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058d6030",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('058d6030')) {
      api.createRecord('058d6030', component.options)
    } else {
      api.reload('058d6030', component.options)
    }
    module.hot.accept("./editDialog.vue?vue&type=template&id=058d6030&scoped=true&", function () {
      api.rerender('058d6030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ads/task/dialog/editDialog.vue"
export default component.exports